import BaseStore from "./BaseStore";
import ApiCalendar from "react-google-calendar-api";

class DocStore extends BaseStore {
  fetch(type = "inbox", per = 10, page = 1, q = "", ordered) {
    const params = {};
    switch (type) {
      case "inbox":
        params.inbox = 1;
        if (ordered)
        params.unread = 1;

        break;
      case "draft":
        params.draft = 1;
        break;
      case "sent":
        params.sent = 1;
        break;
      case "pending":
        params.pending = 1;
        break;
      case "review":
        params.review = 1;
        break;
      case "pass":
          params.pass = 1;
          break;
      case "approve":
          params.approve = 1;
          break;
      case "physical":
          params.physical = 1;
          break;
      case "all":
        params.q = q;
        break;
      default:
        break;
    }
    params.per = per;
    params.page = page;

    return this.axios.get("/docs", { params: params }).catch(this.error);
  }

  getReadChannel(id, onMessage) {
    return this.cable().subscriptions.create(
      { channel: "DocReadChannel", id: id },
      {
        received: onMessage
      }
    );
  }

  getInboxChannel(onMessage) {
    return this.cable().subscriptions.create(
      { channel: "InboxDocumentChannel", email: this.email() },
      {
        received: onMessage
      }
    );
  }


  uploadFile(doc_id, files, onProgress) {
    const data = new FormData();
    for (let x = 0; x < files.length; x++) {
      data.append("files[]", files[x]);
    }

    return this.axios.put(`/docs/${doc_id}/add_file`, data, {
      //time out about 3 hours
      timeout: 10000000
    });
  }

  save_event(doc_id, event) {
    return this.axios.put(`/docs/${doc_id}/save_event`, event);
  }

  save_comment(doc_id, comment) {
    return this.axios.put("/docs/" + doc_id + "/review", {
      note: comment
    });
  }

  save_comment_approve(doc_id, comment) {
    return this.axios.put("/docs/" + doc_id + "/return", {
      note: comment
    });
  }

  deleteFile(doc_id, f) {
    return this.axios.put(`/docs/${doc_id}/remove_file`, {
      name: f.split("/").pop()
    });
  }

  downloadAttacment(f) {
    const nameSplit = f.split("/").pop();
    const name = nameSplit.replace(/%CC%81/g, '').replace(/%CC%83/g, '');
    this.axios.get(f, { responseType: "blob" }).then(r => {
      const url = window.URL.createObjectURL(
        new Blob([r.data], { type: r.data.type })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", name);
      document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(url);
      link.remove();
    });
  }

  getDoc(id) {
    if (id === "new") return this.axios.get("/docs/new");
    return this.axios.get("/docs/" + id);
  }

  replyDoc(doc, all) {
    return this.axios.put("/docs/reply_document",{
      doc_id: doc,
      reply_all: all,
    });

  }

  askPhysicalDoc(id){
    return this.axios.put(`/docs/${id}/request_physical_copy`,{
      id: id
    });

  }

  sendPhysicalDoc(id, to){
    return this.axios.put(`/docs/${id}/send_physical_copy`,{
      id: id,
      to_id: to
    });

  }

  addDoc(doc) {
    return this.axios.post("/docs", doc).catch(this.error);
  }

  setDoc(doc) {
    return this.axios.put("/docs/" + doc.id, doc);
  }

  resend(doc_id, notice_attributes, option, originalTo) {
    let authorized = false;
    if(option === 'authorize'){
      authorized = true;
    }

    //request
    return this.axios.patch("/docs/" + doc_id + "/forward",
    {...notice_attributes, authorized: authorized, original_to_id: originalTo}
    );
}

  save(doc) {

    if (doc.id === undefined || doc.id === null) {
      const {
        from,
        to_id,
        address,
        created_by,
        date,
        body,
        user_group_id,
        notices_attributes,
        notice_user_list,
        external,
        ext_name,
        ext_job_title,
        subject,
        parent_link,
        parent_folio,
        parent_id
      } = doc;
      return this.addDoc({
        from_id: from.id,
        to_id: to_id,
        user_group_id: user_group_id,
        address_id: address.id,
        created_by_id: created_by.id,
        date: date,
        body: body,
        notices_attributes: notices_attributes,
        notice_user_list: notice_user_list,
        external: external,
        ext_name: ext_name,
        ext_job_title: ext_job_title,
        subject: subject,
        parent_folio: parent_folio,
        parent_link: parent_link,
        parent_id: parent_id
      });
    } else {
      doc.notices_attributes = doc.notices_attributes;
      doc.notice_user_list = doc.notice_user_list;
      return this.setDoc(doc);
    }
  }

  send_or_sign(doc) {
    if (this.email() === doc.from.email || doc.has_approver === true)
      return this.axios.patch("/docs/" + doc.id + "/send");
    return this.axios.patch("/docs/" + doc.id + "/request_sign");
  }

  handleRevision(doc) {
      return this.axios.patch("/docs/" + doc.id + "/request_approval");
  }

  send_event(event) {
    //the folio didn't save any event to be sent
    if (isNaN(event.id)) return Promise.resolve({ status: 204 });
    const request = ApiCalendar.gapi.client.request({
      path: "https://www.googleapis.com/calendar/v3/calendars/primary/events",
      method: "POST",
      params: { sendUpdates: "all", conferenceDataVersion: 1 },
      body: event.data
    });
    return request;
  }

  changeDocField(id, field, value) {
    let doc = this.getDoc(id);
    doc[field] = value;
    this.setDoc(doc);
  }

  delete(id) {
    return this.axios.delete("/docs/" + id);
  }

  send_aprove(user, doc){
    return this.axios.patch("/docs/" + doc + "/reviewer_pass",{
      document_id: Number(doc),
      to_id: Number(user)
    });
  }

  mass_sign(docs, per, page){
    return this.axios.put("/documents/mass_sign",{
      documents: docs,
      review: true,
      per: Number(per),
      page: Number(page)
    });
  }

  printDoc(id){
    return this.axios.get(`/docs/print/${id}`, {responseType: 'blob'});
  }

  download(){
    return this.axios.get(`/documents/download`, {responseType: 'blob'});
  }

}
export default new DocStore();



// WEBPACK FOOTER //
// ./src/stores/DocStore.js